import React from "react";
import { MdOutlineAdd } from "react-icons/md";

import "./styles.scss";
import { ChatModels } from "../index";

const ConversationHistory = ({ newConversation, selectedModel, showModels }) => {
    return (
        <div className="conversation-history-container">
            <div className="converstaion-actions">
                <div className="action-item-wrapper" onClick={() => newConversation({ model: selectedModel })}>
                    <div className="action-icon"><MdOutlineAdd /></div>
                    <div className="action-text">New Chat</div>
                </div>
                {showModels && ChatModels?.map((model) => {
                    return (
                        <div className="action-item-wrapper" key={model.id} onClick={() => newConversation({ model: model })}>
                            <div className="action-icon">{model.icon}</div>
                            <div className="action-text">{model.title}</div>
                        </div>
                    )
                })}
            </div>
            <div className="converstaion-items-container">
                No Conversation History Available
            </div>
        </div>
    )
}

export default ConversationHistory